module.exports = __webpack_public_path__ + "img/tax_report.2031dbd2.png";